import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PlaceSearchResult } from './search-google-maps/search-google-maps.component';

@Component({
  selector: 'app-google-map',
  templateUrl: './google-map.component.html',
  styles: ``
})
export class GoogleMapComponent implements OnInit {
  @Input() lat: number = 0;
  @Input() lng: number = 0;
  @Input() lable!: string;
  @Input() canPick: boolean = false;
  @Input() allowSearch: boolean = false;
  @Input() isRequired: boolean = false;

  @Output() Location = new EventEmitter<LocationInterface>();

  // selectedPlace!: PlaceSearchResult | undefined;
  mapOptions!: google.maps.MapOptions;
  marker!: google.maps.MarkerOptions;
  MapCenter!: any
  MapZoom!: any
  // MapInfo!: google.maps.InfoWindowOptions

  ngOnInit(): void {
    if (this.lat && this.lng) {
      this.marker = {
        position: {
          lat: Number(this.lat),
          lng: Number(this.lng)
        },
        label: this.lable ? { text: this.lable, className: 'map_lable' } : null
      }

      // this.MapInfo = { content: this.lable, position: this.marker.position };

      this.MapCenter = {
        lat: Number(this.lat),
        lng: Number(this.lng)
      }
      this.MapZoom = null;
    } else {
      this.MapCenter = {
        lat: 24.774265,
        lng: 46.738586
      }

      this.MapZoom = 7;
    }


    this.mapOptions = {
      mapId: 'customMap15',
      scrollwheel: true,
      disableDoubleClickZoom: false,
      mapTypeId: 'roadmap',
      zoomControl: true,
      fullscreenControl: true,
      mapTypeControl: false,
      streetViewControl: false
    }

  };


  pickMap(event: google.maps.MapMouseEvent) {
    this.marker = {
      position: {
        lat: Number(event.latLng?.lat()),
        lng: Number(event.latLng?.lng())
      }
    }
    this.MapZoom = null;

    this.Location.emit({
      map_lat: Number(event.latLng?.lat()),
      map_lang: Number(event.latLng?.lng())
    })
  }

  OnSelectFromSearch(event: PlaceSearchResult) {
    this.MapCenter = {
      lat: Number(event.location?.lat),
      lng: Number(event.location?.lng)
    };

    this.marker = {
      position: {
        lat: Number(event.location?.lat),
        lng: Number(event.location?.lng)
      }
    }

    this.MapZoom = 15;

    this.Location.emit({
      map_lat: Number(event.location?.lat),
      map_lang: Number(event.location?.lng)
    })
  }

}

export interface LocationInterface {
  map_lang: number,
  map_lat: number
}